import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Modal from "reboron/DropModal";

import * as userAction from "../../actions/userAction";

import { PageHeader } from "../../components/PageHeader";
import UserPasswordView from "../../components/UserPasswordView";
import Tab from "../../components/Tab";
import Tabs from "../../components/Tabs";
import GlobalParams from "../../components/GlobalParams";

/**
 * Komponent zawierający ustawienia.
 * 
 * Widok zawiera dwa taby, do zmiany parametrów globalnych oraz zmiany hasła.
 * 
 */
class Settings extends Component {

  state = {
    //zawartosc modala (doda, edytuj, usun)
    modalContent: null
  };

  showTabContentUser() {
    return (
      <div className="w3-container">

        <button
          className="w3-btn w3-theme-dark"
          onClick={() => this.onEditPasswdClick()}
        >
          {this.props.formatMessage("app.settingsPage.editUserPassword")}
        </button>

      </div>
    )
  }

  /**
  * Pokazuje modal
  */
  showModal() {
    this.refs.modal.show();
  }

  /**
   * Chowa modal
   */
  hideModal = () => {
    if (this.state.modalContent !== null) {
      this.setState({ modalContent: null });
      this.refs.modal.hide();
    }
  };

  /**
  * Akcja po zatwierdzeniu aktualizacji hasła
  */
  onUpdatePasswordAction = data => {
    this.props.onUpdatePassword(data);
    this.hideModal();
  };

  /**
   * Akcja na klik edycji wiersza w tabelce -hasło
   */
  onEditPasswdClick = data => {
    this.setState({
      modalContent: (
        <UserPasswordView
          title={this.props.formatMessage("app.settingsPage.editUserPassword")}
          userId={this.props.authenticatedUser.id}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onUpdatePasswordAction}
        />
      )
    });

    this.showModal();
  };

  render() {

    return (
      <div>
        <PageHeader text="app.settingsPage.title" />

        <Tabs>
          <Tab name="Parametry globalne">

            <GlobalParams />
          </Tab>
          <Tab name="Użytkownik">

            {this.showTabContentUser()}
          </Tab>
        </Tabs>

        <Modal ref={"modal"}>
          {this.state.modalContent}
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {// 
    authenticatedUser: state.authReducer.authenticatedUser
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUpdatePassword: userPassword => {
      dispatch(userAction.updateUserPassword(userPassword));
    }
  };
};

Settings.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  authenticatedUser: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);